import * as React from "react";
import { css } from "@nju/css";
import { IInvoice } from "@nju/data-access-portal-payment";
import { Box, Text } from "@nju/ui";
import { formatDate } from "@nju/utils";
import { MoreButton } from "../MoreButton";
import {
  formatPrice,
  getName,
  getPaymentColor,
  getPaymentStatus,
} from "../utils";

interface IDesktopProps {
  invoice: IInvoice;
  onInvoiceSend: (id: string) => void;
}

export function Desktop({ invoice, onInvoiceSend }: IDesktopProps) {
  const {
    invoiceNumber,
    product,
    documentType,
    invoiceType,
    correctiveInvoiceTime,
    invoiceTime,
    invoiceUrl,
    totalPrice,
    id,
    paymentStatus = "",
  } = invoice;

  const onSend = React.useCallback(() => {
    onInvoiceSend(id);
  }, [id, onInvoiceSend]);

  return (
    <tr>
      <td className={styles.column()} data-label="data">
        {formatDate(
          invoiceType === "CORRECTIVE" && correctiveInvoiceTime
            ? correctiveInvoiceTime
            : invoiceTime,
          false,
        )}
      </td>
      <td className={styles.column()} data-label="opis">
        <Text weight={{ "@onlyMobile": "bold" }}>{product.offeringName}</Text>
      </td>
      <td className={styles.column()} data-label="typ">
        <Text weight={{ "@onlyMobile": "bold" }}>
          {getName(documentType, invoiceType)}
        </Text>
      </td>
      <td className={styles.column()} data-label="numer">
        <Text className={styles.number()} weight={{ "@onlyMobile": "bold" }}>
          {invoiceNumber}
        </Text>
      </td>
      <td className={styles.column()} data-label="kwota">
        <Box display="flex" flexDirection="column">
          <Text className={styles.price()} weight="bold">
            {formatPrice(+totalPrice.grossAmount)}
          </Text>
          <Text size="s" tone={getPaymentColor(paymentStatus)} weight="regular">
            {getPaymentStatus(paymentStatus)}
          </Text>
        </Box>
      </td>
      <td className={`${styles.column()} ${styles.lastColumn()}`} data-label="">
        <MoreButton invoiceUrl={invoiceUrl} onInvoiceSend={onSend} />
      </td>
    </tr>
  );
}

const styles = {
  column: css({
    py: "$15",
    pr: "$10",
    pl: "$5",
    borderTop: "1px solid $porcelain",
  }),
  lastColumn: css({
    pr: "$5",
  }),
  number: css({
    wordBreak: "break-word",
  }),
  price: css({
    whiteSpace: "nowrap",
  }),
};
